import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/sponsors/Tittle'
import SideBar from '../../Components/sponsors/SideBar'
import Subsribe from '../../Components/sponsors/Subsribe'
import Client from '../../Components/sponsors/Client'

const Sponsors = () => {
  return (
    <Main>
<Tittle/>
<SideBar/>
<Client/>
<Subsribe/>

    </Main>
  )
}

export default Sponsors